/**
 * @param {boolean} isLoading - IsLoading.
 * @description Change flag of loading app.
 */
export function setAppIsLoading(isLoading: boolean) {
	document.documentElement.setAttribute('app-is-loading', String(isLoading));
}

/**
 * @description GetAppIsLoading.
 * @returns {boolean} AppIsLoading.
 */
export function getAppIsLoading(): boolean {
	return !!document.documentElement.getAttribute('app-is-loading');
}
